import PropTypes from 'prop-types'

const IconChevronRight = ({ style }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" style={style}>
      <path d="M9.69962 6.4248C9.98295 6.4248 10.2165 6.51686 10.3998 6.7002L15.0004 11.2998C15.1003 11.3998 15.1713 11.5084 15.2133 11.625C15.2546 11.7416 15.2748 11.8667 15.2748 12C15.2748 12.1333 15.2546 12.2584 15.2133 12.375C15.1713 12.4916 15.1003 12.6002 15.0004 12.7002L10.3998 17.2998C10.2165 17.4831 9.98295 17.5752 9.69962 17.5752C9.41651 17.5751 9.18363 17.483 9.0004 17.2998C8.81706 17.1165 8.72501 16.8829 8.72501 16.5996C8.72509 16.3165 8.81715 16.0836 9.0004 15.9004L12.8998 12L9.0004 8.09961C8.81715 7.91636 8.72509 7.68355 8.72501 7.40039C8.72501 7.11706 8.81706 6.88353 9.0004 6.7002C9.18363 6.51701 9.41651 6.42489 9.69962 6.4248Z" fill="#808284"/>
    </svg>
  )
}

IconChevronRight.propTypes = {
  style: PropTypes.object,
}

export default IconChevronRight
